import { render, staticRenderFns } from "./ExFoldTableCell.vue?vue&type=template&id=c8faba24&scoped=true"
import script from "./ExFoldTableCell.vue?vue&type=script&lang=js"
export * from "./ExFoldTableCell.vue?vue&type=script&lang=js"
import style0 from "./ExFoldTableCell.vue?vue&type=style&index=0&id=c8faba24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8faba24",
  null
  
)

export default component.exports